import { Component, inject, Input, OnInit } from '@angular/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { convertMinutesToTime } from '../../../services/ecosystems/helper/convertSecondsToTime';
import { Modal } from 'storybook/internal/components';

@Component({
  selector: 'app-select-timer-control',
  templateUrl: './select-timer-control.component.html',
  styleUrls: ['./select-timer-control.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    IonFooter,
    IonItem,
    IonLabel,
    IonList,
    TranslatePipe,
  ],
})
export class SelectTimerControlComponent implements OnInit {
  @Input() title?: string;
  @Input() value?: string = '';
  @Input() minuteInterval: number = 30;

  private modalController: ModalController = inject(ModalController);

  selectedValue: any = null;

  public list: any = [];

  constructor() {}

  ngOnInit() {
    for (let i = 0; i < 60 * 24; i = i + this.minuteInterval) {
      this.list.push({ label: convertMinutesToTime(i), ref: i });
    }
  }

  openModal() {
    this.selectedValue = this.value;
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  selectItem(itemRef: number) {
    this.selectedValue = itemRef;
  }

  async confirmSelection() {
    await this.modalController.dismiss({ value: this.selectedValue });
  }
}
